export default function getRedirectBaseUrl() {
  if (window.location.hash) {
    const currLocation = window.location.href;
    const newLoc = currLocation.substring(0, currLocation.indexOf('#'));
    return newLoc;
  } else {
    return window.location.href;
  }
}
